export default {
  helpCenterArr(state) {
    return state.infoList.data.filter((item) => item.categoryId === '3');
  },
  helpCenterObj(state, getters) {
    return getters.helpCenterArr.length ? getters.helpCenterArr[0] : null;
  },
  helpCenter(state, getters) {
    return getters.helpCenterObj ? getters.helpCenterObj.child : [];
  },
};
